import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeurecmdComponent } from './heurecmd.component';
import { ReactiveFormsModule } from '@angular/forms';
import { MatChipsModule } from '@angular/material';
import { MaterialModule } from 'src/@fury/shared/material-components.module';
import { BreadcrumbsModule } from 'src/@fury/shared/breadcrumbs/breadcrumbs.module';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { FuryCardModule } from 'src/@fury/shared/card/card.module';
import { AddheurecmdComponent } from './addheurecmd/addheurecmd.component';

@NgModule({
  declarations: [HeurecmdComponent,AddheurecmdComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatChipsModule,
    MaterialModule,
    BreadcrumbsModule,
    NgxDatatableModule,
    FuryCardModule,
    MatChipsModule,
  ],
  entryComponents : [AddheurecmdComponent]
})
export class HeurecmdModule { }
